import { Box } from "@mui/material";
import React from "react";
import { colorVariables, customValue } from "../../../utils/colorVariable";

interface IContainer {
  children: React.ReactNode;
}

export const Container: React.FC<IContainer> = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        justifyContent: "center",
        width: "100%",
        px: 4,
        boxSizing: "border-box",
        backgroundColor: colorVariables.white,
      }}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        bgcolor={colorVariables.lightWhite}
        mt={7.5}
        mb={8}
        py={1}
        px={0.5}
        borderRadius={customValue.borderRadius}
        gap={0.5}
      >
        {children}
      </Box>
    </Box>
  );
};
